import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { BsInfoCircleFill } from 'react-icons/bs';
import './popover.css';

const PopOver = ({ data, placement, message }) => {
    // console.log(data);
    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: 100, hide: 100 }}
            overlay={
                <Popover id="popover-basic">
                    <Popover.Body className='p-2' style={{ fontWeight: "600" }} >
                        {data ? data?.map((_theme_ele, key) => key === data?.length - 1 ? _theme_ele : `${_theme_ele}, `) : message}
                    </Popover.Body>
                </Popover>
            }
        >
            <span className='cursor-pointer position-absolute m-auto d-flex align-items-center' style={{ right: "7px", top: "0", bottom: "0", height: "100%" }}><BsInfoCircleFill /></span>
        </OverlayTrigger>
    )
}

export default PopOver;
